angular.module('unergie.main')
.controller('subscriptionListsCtrl', ($scope, $state, BoFeaturesService, AlertManager, ModalService, TableGeneratorService, DataAccess, ApiAdmin, ErrorCatcher) => {
    $scope.booleanFilter = [{ id: 'true', title: 'Oui' }, { id: 'false', title: 'Non' }]

    $scope.subscriptionLists = {
        refreshing: false,
        show: {},
        columns: {
            id: { label: 'ID', mode: 'search_operator', mandatory: true },
            functional_id: { label: 'ID fonctionnel', mode: 'search_wildcard' },
            category: { label: 'Catégorie', mode: 'search_wildcard' },
            label: { label: 'Libellé', mode: 'search_wildcard' },
            wording_client: { label: 'Wording client', mode: 'hidden' },
            wording_vendor: { label: 'Wording vendeur', mode: 'hidden' },
            wording_mobile: { label: 'Wording mobile', mode: 'hidden' },
            status: { label: 'Statut', mode: 'search_wildcard' },
            b2c: { label: 'B2C', mode: 'search_strict' },
            b2g: { label: 'B2G', mode: 'search_strict' },
            b2b: { label: 'B2B', mode: 'search_strict' },
            step: { label: 'Étape', mode: 'search_wildcard' },
            display_order: { label: 'Order affichage', mode: 'search_operator' },
            creation_ts: { label: 'Date de création', mode: 'search_date' },
        },
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.subscriptionLists, 'ref-sendinblue-lists', null, null, { orderBy: 'id' })

    $scope.updateSubscriptionListFields = {
        functional_id: { label: 'ID fonctionnel', type: 'text', required: true },
        category: { label: `Catégorie`, type: 'text', required: true },
        label: { label: `Libellé`, type: 'text', required: true },
        wording_client: { label: `Wording client`, type: 'textarea', required: true },
        wording_vendor: { label: `Wording vendeur`, type: 'textarea', required: true },
        wording_mobile: { label: `Wording mobile`, type: 'textarea', required: true },
        status: { label: `Statut`, type: 'select', required: true, enum: [{ label: 'Cachée', value: 'HIDDEN' }, { label: 'Affichée', value: 'DISPLAYED' }] },
        b2c: { label: `B2C`, type: 'checkbox', required: true },
        b2g: { label: `B2G`, type: 'checkbox', required: true },
        b2b: { label: `B2B`, type: 'checkbox', required: true },
        step: { label: 'Étape', type: 'text' },
        display_order: { label: 'Order affichage', type: 'number' },
    }

    $scope.updateSubscriptionListTemplate = {}

    $scope.newSubscriptionListFields = _.assign({
        id: { label: `Identifiant sendinblue`, type: 'number', required: true },
    }, $scope.updateSubscriptionListFields)

    $scope.newSubscriptionListTemplate = {
        id: null,
        functional_id: null,
        label: null,
        category: null,
        wording_client: null,
        wording_vendor: null,
        wording_mobile: null,
        status: 'HIDDEN',
        b2c: false,
        b2g: false,
        b2b: false,
        step: null,
        display_order: 0,
    }

    $scope.newSubscriptionList = () => {
        $scope.creating = true
        return ApiAdmin.newSendInBlueSubscriptionList($scope.newSubscriptionListTemplate).$promise
        .then((result) => {
            AlertManager.success(result.message, 6000)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.creating = false
        })
    }

    $scope.fillSubscriptionListTemplate = (subscriptionList) => {
        _.assign($scope.updateSubscriptionListTemplate, _.pick(subscriptionList, [
            'label',
            'category',
            'status',
            'b2c',
            'b2g',
            'b2b',
            'functional_id',
            'wording_client',
            'wording_vendor',
            'wording_mobile',
            'step',
            'display_order',
        ]))
    }

    $scope.updateSubscriptionList = (subscriptionList) => {
        subscriptionList.updating = true
        return DataAccess.updateSendInBlueSubscriptionList({ id: subscriptionList.id }, $scope.updateSubscriptionListTemplate).$promise
        .then((result) => {
            AlertManager.success(result.message, 6000)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            subscriptionList.updating = false
        })
    }

    const getSubscriptionListDetails = (subscriptionList) => {
        subscriptionList.fetchingDetails = true
        return ApiAdmin.getContactListDetails({ id: subscriptionList.id }).$promise
        .then((result) => {
            subscriptionList.details = result
        })
        .catch(ErrorCatcher)
        .finally(() => {
            subscriptionList.fetchingDetails = false
        })
    }

    const getSubscriptionListStats = (subscriptionList) => {
        subscriptionList.fetchingStats = true
        return DataAccess.fetchSendInBlueSubscriptionListStats({ id: subscriptionList.id }).$promise
        .then((result) => {
            subscriptionList.stats = result
        })
        .catch(ErrorCatcher)
        .finally(() => {
            subscriptionList.fetchingStats = false
        })
    }

    $scope.toggleExpand = (subscriptionList) => {
        subscriptionList.expanded = !subscriptionList.expanded
        if (!subscriptionList.details || !subscriptionList.stats) {
            getSubscriptionListDetails(subscriptionList)
            getSubscriptionListStats(subscriptionList)
        }
    }

    $scope.refresh()
})
